/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AvatarGreenSvg from './icon-avatar-green.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <AvatarGreenSvg {...validProps} />;
}
SvgComponent.iconName = 'avatarGreen';

export const AvatarGreenIcon = svgIconWrapper(SvgComponent);
